import { SearchBaseModel, DateRange } from '../commonModels';

export class CostEstimationSearchModel extends SearchBaseModel {

  constructor() {
    super();

    this.RegistrationNumber = null;

    this.GarageId = null;

    this.CustomerId = null;

    this.Garage = null;

    this.Customer = null;

    this.CostEstimationNumber = null;

    this.CostEstimationsStatusId = null;

    this.CostEstimationsStatus = null;

    this.IsOrderReleted = null;

    this.PeriodDateRange = new DateRange();

    this.period = null;
  }

  public RegistrationNumber: string;

  public GarageId: number;

  public CustomerId: number;

  public Garage: string;

  public Customer: string;

  public CostEstimationNumber: string;

  public CostEstimationsStatusId: number;

  public CostEstimationsStatus: string;

  public IsOrderReleted: boolean;

  public PeriodDateRange: DateRange;

  public period: any;

  public CarId: number;
}
